
<template>
    <div class="pp-folder-item">
        <div class="pp-folder-item__title" @click="$parent.update(name)">
            <slot name="title" class="title">{{title}}</slot>
            <i v-if="currentWithIcon" class="pp-folder-item__icon pp-icon-arrow-down" :class="{up: isActive}"></i>
        </div>
        <transition 
            @enter="enter" 
            @leave="leave">
            <div v-show="isActive" ref="wrap" class="pp-folder-item__wrap"
                :style="{ height: height+'px', }">
                <div ref="container" class="pp-folder-item__content">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/**
 * 折叠面板-子项
 * @desc 该组件依赖于<pp-folder>
 * @param {string} title 面板标题
 * @param {string} name 面板名，用于绑定到组件<pp-folder>激活项
 * @param {boolean} withIcon 是否带折叠状态图标(会被父级<pp-folder>的withIcon覆盖)
 */
export default {
    name: 'pp-folder-item',
    props: {
        title: [String, Number],
        name: [String, Number],
        withIcon: Boolean,
    },
    data: function() {
        return {
            height: '',
        };
    },
    computed: {
        value: function() {
            return this.$parent.value;
        },
        isAccordion: function() {
            return this.$parent.accordion;
        },
        isActive: function() {
            if(this.isAccordion) {
                return this.value === this.name;
            }
            else {
                let isExist = this.value.find(v=> v === this.name);
                return !!isExist;
            }
        },
        currentWithIcon: function() {
            return this.$parent.withIcon || this.withIcon;
        },
    },
    methods: {
        enter: function(el) {
            this.height = el.firstChild.offsetHeight
        },

        leave: function(el) {
            this.height = 0
        },
    },
    mounted: function() {
        this.isActive && this.enter(this.$refs['wrap'])
    },
}
</script>